import jwt_decode from "jwt-decode";
import { isEmpty } from 'lodash'
import { getCookie } from "./cookie";

export default () => {
 const cookiesToken = getCookie('aupd_token')
 return !isEmpty(cookiesToken) ? jwt_decode(cookiesToken) : {}
}